import {
  ACC_INFO_CITY,
  ACC_INFO_STATE,
  INVALID_FORMAT_ERR,
  MANDATORY_FIELD_ERR,
  VALIDATION_BACKSPACE,
} from '../../constants';
import data from '../../json-data/address.json';

export const addAutoCompleteCityToDropdownLogin = (
  autoCompleteCountry,
  autoCompleteState,
  autoCompleteCity
) => {
  if (autoCompleteCountry && autoCompleteState) {
    let cityPresent = false;
    data[autoCompleteCountry].forEach((e) => {
      if (e.stateInitial === autoCompleteState) {
        for (const city of e.city) {
          if (city === autoCompleteCity) {
            cityPresent = true;
            break;
          }
        }
      }
    });
    return cityPresent;
  }
  return false;
};

export const returnCityListLogin = (element, loginHomeAddress) => {
  const cityList = [];
  if (element === ACC_INFO_CITY && loginHomeAddress?.country) {
    data[loginHomeAddress.country].forEach((e) => {
      if (loginHomeAddress.state && e.stateInitial === loginHomeAddress?.state) {
        e.city.sort().map((city) => cityList.push(city));
      }
    });
  }
  if (loginHomeAddress?.missingAutoCompleteCity) {
    cityList.push(loginHomeAddress.missingAutoCompleteCity);
  }
  return cityList;
};

export const returnStateListLogin = (element, loginHomeAddress) => {
  const stateList = [];
  if (element === ACC_INFO_STATE) {
    if (loginHomeAddress?.country) {
      data[loginHomeAddress.country].forEach((e) => {
        const stateDetails = {
          stateInitial: e.stateInitial,
          stateFullName: e.stateFullName,
        };
        stateList.push(stateDetails);
      });
    }
  }
  return stateList;
};

export const loginAddress2Change = (e, context) => {
  const { setLoginHomeAddress, setLoginHomeAddressErrors } = context;
  if (e.target.value && e.target.value.length > 0) {
    if (
      e.target.value.match(/^[A-Za-z0-9'#@%&\\/.\-\s,]+$/) &&
      e.target.value?.length >= 2 &&
      e.target.value.length <= 30
    ) {
      setLoginHomeAddress((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setLoginHomeAddressErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
    } else if (e.target.value.length > 30) {
      setLoginHomeAddress((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Address Line 2 should have max 30 characters.',
      }));
    } else {
      setLoginHomeAddress((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Invalid address',
      }));
    }
  } else {
    const { value } = e.target;
    setLoginHomeAddress((prevState) => ({ ...prevState, [e.target.name]: value || '' }));
    setLoginHomeAddressErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
  }
};
export const loginCountryChange = (e, context) => {
  const { setLoginHomeAddress, setLoginHomeAddressErrors } = context;
  if (e.target.value && e.target.value.length > 0) {
    setLoginHomeAddress((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
      state: '',
      city: '',
    }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
      state: '',
      city: '',
    }));
  } else {
    setLoginHomeAddress((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value ? e.target.value : '',
      state: '',
      city: '',
    }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
      state: '',
      city: '',
    }));
  }
};
export const loginStateChange = (e, context) => {
  const { setLoginHomeAddress, setLoginHomeAddressErrors } = context;
  if (e.target.value && e.target.value.length > 0) {
    setLoginHomeAddress((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
      city: '',
    }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
      city: '',
    }));
  } else {
    setLoginHomeAddress((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value ? e.target.value : '',
      city: '',
    }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
      city: '',
    }));
  }
};
export const loginCityChange = (e, context) => {
  const { setLoginHomeAddress, setLoginHomeAddressErrors } = context;
  if (e.target.value && e.target.value.length > 0) {
    setLoginHomeAddress((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setLoginHomeAddressErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
  } else {
    setLoginHomeAddress((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value ? e.target.value : '',
    }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  }
};
export const loginZipcodeChange = (e, context) => {
  const { setLoginHomeAddress, setLoginHomeAddressErrors } = context;
  if (e.target.value?.match(/^\d+$/) || e.key === VALIDATION_BACKSPACE) {
    setLoginHomeAddress((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setLoginHomeAddressErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));

    if (e.target.value.length < 5) {
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Zipcode should have 5 digits',
      }));
    } else if (e.target.value?.match(/^0*$/g)) {
      setLoginHomeAddressErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Please enter a valid zipcode',
      }));
    } else {
      setLoginHomeAddressErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
    }
  } else if (e.target.value === '') {
    setLoginHomeAddress((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setLoginHomeAddress((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setLoginHomeAddressErrors((prevState) => ({
      ...prevState,
      [e.target.name]: INVALID_FORMAT_ERR,
    }));
  }
};
